import { useEffect } from "react";
import { useLocation } from "wouter";
import { useAuthMe } from "@vorloop/api-client-react";

/**
 * Gate guarded routes. Renders a spinner while auth is loading; redirects
 * to /signin when no session; renders children otherwise. Wraps any page
 * that requires auth.
 */
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const [, setLocation] = useLocation();
  const me = useAuthMe();

  useEffect(() => {
    if (me.isLoading) return;
    if (!me.data?.user) setLocation("/signin");
  }, [me.isLoading, me.data, setLocation]);

  if (me.isLoading) return <LoadingSplash />;
  if (!me.data?.user) return <LoadingSplash />;
  return <>{children}</>;
}

function LoadingSplash() {
  return (
    <div
      style={{
        height: "100vh",
        display: "grid",
        placeItems: "center",
        background: "var(--bg-canvas)",
        color: "var(--text-tertiary)",
        fontSize: 12,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <span
          aria-hidden
          style={{
            width: 14,
            height: 14,
            border: "2px solid var(--border-strong)",
            borderTopColor: "var(--accent-blue)",
            borderRadius: 7,
            animation: "vp-spin 0.9s linear infinite",
            display: "inline-block",
          }}
        />
        Loading…
      </div>
    </div>
  );
}
